import { render, staticRenderFns } from "./ParentPortal.vue?vue&type=template&id=6091ee31&scoped=true&"
import script from "./ParentPortal.vue?vue&type=script&lang=js&"
export * from "./ParentPortal.vue?vue&type=script&lang=js&"
import style0 from "./ParentPortal.vue?vue&type=style&index=0&id=6091ee31&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6091ee31",
  null
  
)

export default component.exports